export * from "./dracoCompression.js";
export * from "./meshoptCompression.js";
//# sourceMappingURL=index.js.map